import useNng from "../../component/nng/useNng";
import { Box, Grid, Skeleton, Typography } from "@mui/material";

const LoadingLayout = () => {
  const [pageState] = useNng();

  const numeriSpecialiPapersList = pageState.map((ns, idx) => (
    <Grid item xs={12} md={6} lg={3} key={`numeri-speciali-papers-${ns.id}`}>
      <Skeleton variant={"rectangular"} height={70} />
    </Grid>
  ));

  return (
    <Box mt={"2.5em"}>
      <Typography variant={"h6"} fontWeight={"bold"}>
          Numerazioni Speciali
      </Typography>
      <Typography variant="body2" my={2} />
      <Grid container spacing={2} mb={4}>
        {numeriSpecialiPapersList}
      </Grid>
      <Skeleton height={40} width={300} variant={"rectangular"} />
      <Skeleton height={30} variant={"rectangular"} sx={{ mt: 2 }} />
      <Skeleton
        height={60}
        width={600}
        variant={"rectangular"}
        sx={{ mt: 3 }}
      />
      <Skeleton height={300} variant={"rectangular"} sx={{ mt: 2 }} />
    </Box>
  );
};

export default LoadingLayout;
